import RBush from 'rbush';
import * as React from 'react';

import { IFrecklesRBushItem } from '../../../../common/types/freckles';
import { IRBushItem } from '../../../../common/types/map';

interface IUsePinsLayerParams {
  ymaps: YMaps.IYMaps;
  map: YMaps.Map;
  isRedesign: boolean;
}

export interface IPinsLayer {
  rbush: RBush<IRBushItem>;
  rbushFreckles: RBush<IFrecklesRBushItem>;
  pointsLayer: YMaps.PointsLayer;
  frecklesPointsLayer: YMaps.FrecklesPointsLayer;
  hotspotsLayer: YMaps.HotspotsLayer;
  balloonManager: YMaps.BalloonManager;
}

export function usePinsLayer({ ymaps, map, isRedesign }: IUsePinsLayerParams): IPinsLayer {
  const rbushRef = React.useRef(new RBush<IRBushItem>());
  const rbushFrecklesRef = React.useRef(new RBush<IFrecklesRBushItem>());
  const pointsLayerRef = React.useRef(new ymaps.PointsLayer({ map, rbush: rbushRef.current }));
  const frecklesPointsLayerRef = React.useRef(
    new ymaps.FrecklesPointsLayer({ map, rbush: rbushFrecklesRef.current, isRedesign }),
  );
  const hotspotsLayerRef = React.useRef(new ymaps.HotspotsLayer({ map, rbush: rbushFrecklesRef.current }));
  const balloonManagerRef = React.useRef(new ymaps.BalloonManager({ map, rbush: rbushRef.current }));

  React.useEffect(() => {
    const pointsLayer = pointsLayerRef.current;
    const frecklesPointsLayer = frecklesPointsLayerRef.current;
    const hotspotsLayer = hotspotsLayerRef.current;
    const balloonManager = balloonManagerRef.current;

    map.layers.add(pointsLayer.layer);
    map.layers.add(frecklesPointsLayer.layer);
    map.layers.add(hotspotsLayer.layer);
    map.geoObjects.add(balloonManager.objectManager);

    return () => {
      map.layers.remove(pointsLayer.layer);
      map.layers.remove(frecklesPointsLayer.layer);
      map.layers.remove(hotspotsLayer.layer);
      map.geoObjects.remove(balloonManager.objectManager);
    };
  }, [map]);

  return {
    rbush: rbushRef.current,
    rbushFreckles: rbushFrecklesRef.current,
    pointsLayer: pointsLayerRef.current,
    frecklesPointsLayer: frecklesPointsLayerRef.current,
    hotspotsLayer: hotspotsLayerRef.current,
    balloonManager: balloonManagerRef.current,
  };
}
